<template>
  <div class="detaill">
    <!-- 返回 -->
    <!-- <div class="back" v-show="showback">
      <img
        :src="'https://puui.qpic.cn/vupload/0/20200709_mixpjrqf0a/0'"
        class="details-img"
        @click="Goback"
      />
      <div class="details-return" @click="Goback">返回</div>
    </div> -->
    <!-- 头部 -->
    <el-card class="box-card">
      <div class="header">
        <div class="up" :class="{ border: showData }">
          <div class="user">
            <div class="avatar">
              <!-- <el-avatar
                :size="60"
                src="./默认头像.png"
              ></el-avatar> -->
              <img :src="g_imgSrc.doctorDefault" alt="" />
              <div class="sex">
                <i :class="userInfo.sex === '男' ? 'el-icon-male' : 'el-icon-female'"></i>
              </div>
            </div>

            <h2>{{ userInfo.custom_name || '-' }}</h2>
            <span>{{ userInfo.representative_code || '-' }}</span>
          </div>
          <div class="company">
            <div class="item">
              <div class="title">所在BU</div>
              <div class="data">{{ userInfo.bu || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">所在中心</div>
              <div class="data">{{ userInfo.center || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">所在省市</div>
              <div class="data">{{ userInfo.province || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">所在区域</div>
              <div class="data">{{ userInfo.area || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">上级DSM</div>
              <div class="data">{{ userInfo.superior_dsm || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">上级RSD</div>
              <div class="data">{{ userInfo.superior_rsd || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">上级RSM</div>
              <div class="data">{{ userInfo.superior_rsm || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">代表类型</div>
              <div class="data">{{ userInfo.type || '-' }}</div>
            </div>
          </div>
        </div>
        <div>
          <el-collapse-transition>
            <div class="info" v-show="showData">
              <div class="item">
                <div class="title">登记时间</div>
                <div class="data">
                  {{
                    userInfo.add_time.seconds ? getdate(userInfo.add_time.seconds, 'yy-mm-dd') : '-'
                  }}
                </div>
              </div>
              <div class="item">
                <div class="title">公司名称</div>
                <div class="data">{{ userInfo.company_name || '-' }}</div>
              </div>
              <div class="item">
                <div class="title">身份证</div>
                <div class="data">{{ userInfo.id_card_no || '-' }}</div>
              </div>
              <div class="item big">
                <div class="title">Region Center(EN)</div>
                <div class="data">{{ userInfo.region_center || '-' }}</div>
              </div>
              <div class="item">
                <div class="title">生日</div>
                <div class="data">
                  {{
                    userInfo.birthday.seconds ? getdate(userInfo.birthday.seconds, 'mm/dd') : '-'
                  }}
                </div>
              </div>
              <div class="item">
                <div class="title">邮箱</div>
                <div class="data">{{ userInfo.email || '-' }}</div>
              </div>
              <div class="item">
                <div class="title">手机号</div>
                <div class="data">{{ userInfo.phone || '-' }}</div>
              </div>
              <div class="item big">
                <div class="title">Regin(EN)</div>
                <div class="data">{{ userInfo.region || '-' }}</div>
              </div>
              <div class="item">
                <div class="title">性别</div>
                <div class="data">{{ userInfo.sex || '-' }}</div>
              </div>
            </div>
          </el-collapse-transition>
          <div class="sw" @click="changeShowData">
            {{ showData ? '收起' : '更多' }}
            <i class="el-icon-arrow-down" :class="{ close: showData }"></i>
          </div>
        </div>
      </div>
    </el-card>
    <br />
    <!-- 关联医生列表 -->
    <el-card class="box-card">
      <h4>关联医生</h4>
      <br />
      <div class="table-list">
        <el-table :data="tablesetupList" style="width: 100%" v-loading="doctortableLoding">
          <template slot="empty">
            <!-- 没有数据 -->
            <NoData></NoData>
            <br />
          </template>
          <el-table-column prop="doctor_name" label="姓名">
            <template slot-scope="scope">
              <div>{{ scope.row.doctor_name ? scope.row.doctor_name : '-' }}</div>
              <div class="representimportid">
                ID: {{ scope.row.doctor_id ? scope.row.doctor_id : '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="hospital_name" label="医院" />
          <el-table-column prop="is_registered" label="注册状态">
            <template slot-scope="scope">
              <div v-if="scope.row.is_registered == '1'">未注册</div>
              <div v-if="scope.row.is_registered == '2'">已注册</div>
            </template>
          </el-table-column>
          <el-table-column prop="department_name" label="科室" />
          <el-table-column prop="title" label="职称" />
          <!-- <el-table-column prop="mobile" label="手机号" /> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="showdoctorDetaill(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pagination"
        style="background-color: #ffffff"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="doctorhandleCurrentChange"
        @size-change="handleSizeChange"
      />
      <br />
      <br />
    </el-card>
  </div>
</template>

<script>
import NoData from '@/components/no-data';
import { getRepresentativeDetailInfoApi, ListRepresentativeDoctorApi } from '@/api/setUp.js';
import { timeStampOne } from '@/utils/time';
export default {
  components: {
    NoData,
  },
  data() {
    return {
      showback: true,
      userInfo: {
        add_time: '-',
        company_name: '-',
        id_card_no: '-',
        region_center: '-',
        birthday: '-',
        email: '-',
        phone: '-',
        region: '-',
        sex: '男',
      },
      // 头部
      loading: false,
      companyInfo: [],
      showData: false,
      // 医生表格
      tablesetupList: [],
      doctortableLoding: false,
      // 分页
      total: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  created() {
    this.pageSize = this.g_pageSizeDefault;

    const { query } = this.$route;
    if (query.id) {
      this.requestuserInfo(query.id);
    } else {
      this.Goback();
    }

    // 判断是否新打开的页面
    if (query.type === 'newWindow') {
      this.showback = false;
    }
  },
  methods: {
    requestuserInfo(id) {
      this.loading = true;
      const req = { id };
      getRepresentativeDetailInfoApi(req)
        .then((res) => {
          this.userInfo = res;
          this.loading = false;
          // 请求医生列表
          this.requestDoctorListData(res);
        })
        .catch(() => {
          this.$message('查询失败');
          this.loading = false;
        });
    },
    requestDoctorListData({ representative_code, enterprise_id }) {
      const req = {
        page_size: this.pageSize,
        page_index: this.currentPage,
        representative_code,
        enterprise_id,
      };
      ListRepresentativeDoctorApi(req)
        .then((res) => {
          this.tablesetupList = res.data;
          this.total = res.total_num;
          // this.pageSize = res.page_size;
          this.doctortableLoding = false;
          this.bottonLoading = false;
        })
        .catch(() => {
          this.$message('查询失败');
          this.doctortableLoding = false;
          this.bottonLoading = false;
        });
    },
    // 返回
    Goback() {
      this.$router.go(-1);
      // 新窗口打开的关闭窗口
      window.close();
    },
    showdoctorDetaill(row) {
      const id = row.doctor_id;
      this.g_tourl(`/saas/doctorInfo.html?doctor_id=${id}&type=newWindow`, { open: true });
    },
    doctorhandleCurrentChange(val) {
      this.currentPage = val;
      this.doctortableLoding = true;
      this.requestDoctorListData(this.userInfo);
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.doctortableLoding = true;
      this.requestDoctorListData(this.userInfo);
    },
    changeShowData() {
      this.showData = !this.showData;
    },
    getdate(value, type) {
      const yy = timeStampOne(value, 'year');
      const mm = timeStampOne(value, 'month');
      const dd = timeStampOne(value, 'day');
      if (type === 'yy-mm-dd') {
        return `${yy}/${mm}/${dd}`;
      }
      return `${mm}/${dd}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
